// Client page to worker embed iframe, these are just wrappers for iframe postMessaging.
export const EMBED_MESSAGE_IDENTIFIER = '__calling_cross_tab_embed_message';

// Standard cross tab message for interaction with the workers and other page clients.
export const CROSS_TAB_MESSAGE_IDENTIFIER = '__calling_cross_tab_message';